import styled from "styled-components";

export const StyledFilterWrapper = styled.div`
  ${({ pt }) => pt && `padding-top: ${pt}px`};
  ${({ pb }) => pb && `padding-bottom: ${pb}px`};
  display: grid;
  grid-template-columns: 175px;
  grid-template-rows: 55px;
  grid-gap: 30px;
  align-items: center;
  /*.filter-search {
    &__text {
      & > div {
        input {
          background: rgba(229 227 235 / 0.5) !important;
        }
      }
    }
    @media screen and (max-width: 599px) {
      display: none;
    }
  }*/
  .rc-dropdown {
    z-index: 1200;
  }
  button {
    height: 100%;
  }
`;

export const StyledShowFilterBtn = styled.div`
  width: 100%;
  height: 100%;
  button {
    width: 100%;
    height: 100%;
    color: rgb(255, 255, 255);
    font-size: 16px;
    font-weight: 600;
    background: linear-gradient(40deg, rgb(39, 118, 97) -20%, rgb(41, 222, 174) 70%);
    border: 0px;
  }
`;

export const StyledFilterGroup = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  position: relative;
  label {
    color: rgba(0, 0, 0, 0.54);
    font-size: 14px;
    transform: translate(0, 1.5px) scale(0.75);
    transform-origin: top left;
  }
  input {
    padding: 5px 0 7px;
    color: #000;
    border: none;
    background-color: transparent;
    border-bottom: 1px solid rgba(0, 0, 0, 0.42);
    &:hover {
      border-bottom: 1px solid rgba(0, 0, 0, 1);
      box-shadow: 0 1px 0 0 rgba(0,0,0,1);
    }
    &:focus {
      border-bottom: 1px solid #3f51b5;
    }

    &::-webkit-input-placeholder {
      opacity: 0.35;
    }
    &:-moz-placeholder {
      opacity: 0.35;
    }
    &::-moz-placeholder {
      opacity: 0.35;
    }
    &:-ms-input-placeholder {
      opacity: 0.35;
    }
  }
`;

export const StyledSelectGroup = styled.div`
  height: 46px;
  width: 100%;
  display: grid;
`;

export const StyledItemsPerPage = styled.div`
  max-width: 175px;
  width: 100%;
  display: grid;
  background-color: #fff;
  label {
    padding: 1px 5px;
    background-color: #fff;
  }
  .MuiSelect-select:focus {
    background-color: transparent;
  }
`;

export const StyledFilterDropdownWrapper = styled.div`
  min-width: 295px;
  max-width: 840px;
  width: 100%;
  margin-top: 10px;
  padding: 15px;
  background-color: white;
  box-shadow: 0 5px 5px -3px rgb(0 0 0 / 20%), 0 8px 10px 1px rgb(0 0 0 / 14%), 0 3px 14px 2px rgb(0 0 0 / 12%);
  border-radius: 4px;
  overflow-y: auto;
  .clear-btn {
    min-height: 42px;
    button {
      padding: 0 15px;
    }
  }
  .close-btn {
    display: inline-flex;
    justify-content: flex-end;
  }

  @media screen and (max-width: 768px) {
    padding: 10px;
  }
`;

export const StyledFilterBlockTitle = styled.div`
  ${({ mt }) => mt && `margin-top: ${mt}px`};
  margin-bottom: ${({mb}) => mb || 5}px;
  color: #277661;
  font-size: 16px;
  font-weight: 700;
`;

export const StyledFilterBlock = styled.div`
  padding: 15px;
  display: grid;
  grid-template-columns: ${({ actions, col }) => actions ? `max-content max-content !important` : `repeat(${col ?? 3}, minmax(0, 260px))`};
  ${({ actions }) => actions && `justify-content: space-between`};
  grid-gap: 15px;
  background-color: ${({ actions }) => actions ? "transparent" : "rgba(245, 244, 250, 0.5)"};
  input {
    padding: 3px 0;
  }
  &:not(&:last-child) {
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  }

  @media screen and (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media screen and (max-width: 768px) {
    padding: 10px;
    grid-template-columns: 100%;
  }
`;

export const StyledFilterCloseBtn = styled.button`
  position: relative;
  height: 30px !important;
  width: 30px !important;
  padding: 0 !important;
  border: none;
  border-radius: 50%;
  transition: all .3s ease;
  &:before {
    content: '\\e900';
    color: #909090;
    font-family: 'cp-icons', serif;
  }
  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
`;